
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexWbiN07ZJSAvqDgDm4zurkxeqvF34rmYsaxYJqrDF0yAMeta } from "/tmp/build_36c146c3/app/pages/index.vue?macro=true";
import { default as shiftR76TDNKvp_45c_nVwT60I3zNYfiTy2pdgUtc6qToJhBu8Meta } from "/tmp/build_36c146c3/app/pages/shift.vue?macro=true";
import { default as homegE0DlfOnX5h7HYhfnfeLjqd2wfMsNGRV_45seBZwWra08Meta } from "/tmp/build_36c146c3/app/pages/[role]/home.vue?macro=true";
import { default as chatstM87T0hudOl5kThZg5hakd9nupZokT48rWCnIPcmgkEMeta } from "/tmp/build_36c146c3/app/pages/[role]/chats.vue?macro=true";
import { default as usersm21EOSGOHx0M7bztH_45U_ZKaUjj3_PaT5scqOk4XWp_45gMeta } from "/tmp/build_36c146c3/app/pages/[role]/users.vue?macro=true";
import { default as calendarvG9Q3A_45c93qYpC3Q41D4hXL51hyWQ_45HABw6mbrPaNJUMeta } from "/tmp/build_36c146c3/app/pages/[role]/calendar.vue?macro=true";
import { default as patientsF96Pck_ub9FfnO8yYChaRnnVoBlUpHWADjDVUY1Q_45_oMeta } from "/tmp/build_36c146c3/app/pages/[role]/patients.vue?macro=true";
import { default as settingsoYrV_45Ktih_qpE3iTWqmyscSJxw_45slIx2XukazPTc5U8Meta } from "/tmp/build_36c146c3/app/pages/[role]/settings.vue?macro=true";
import { default as _91token_93ZI_45MtmAW0ddbUp7lI3YbyGb0EWF6qkWEP13TU00JjJAMeta } from "/tmp/build_36c146c3/app/pages/[role]/email/validation/[token].vue?macro=true";
import { default as _91role_934Lp_bw1budwmPB6fR_FYX2UmJuAmcmrzvMs8ssU80wgMeta } from "/tmp/build_36c146c3/app/pages/[role].vue?macro=true";
import { default as inlAPgujcrDHR5G1K30Z_KWJ1rEV1iuJ03lCh_45nXaZ_45A8Meta } from "/tmp/build_36c146c3/app/pages/sign/in.vue?macro=true";
import { default as upYzzY8_FRpO4hSiaJdGYEPdZp0uA_45VMUIqT32yFfbhZAMeta } from "/tmp/build_36c146c3/app/pages/sign/up.vue?macro=true";
import { default as indexYuLA1OAjN7j355H8ZmGLP4E8NDPpqUY5wKjTf07_45cdQMeta } from "/tmp/build_36c146c3/app/pages/sign/index.vue?macro=true";
import { default as recipeEduNwR_45omrgNeFyotoimQlYDB7k03alqK88_QlstLLkMeta } from "/tmp/build_36c146c3/app/pages/print/recipe.vue?macro=true";
import { default as indexxvvsaohWRO4vgOO1SX2dFuKxZGhU2G3et7wotG_v0eUMeta } from "/tmp/build_36c146c3/app/pages/sign/tfa/index.vue?macro=true";
import { default as _91token_93mrYJYGhqyKnUjr1ZjgLeqLfwwc1A7G113tupXh8520IMeta } from "/tmp/build_36c146c3/app/pages/sign/reset/[token].vue?macro=true";
import { default as _91token_930avVOG40o96BdMbd9ODIz9neyGVqOKhmx6IuiERXi7AMeta } from "/tmp/build_36c146c3/app/pages/sign/validation/[token].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexWbiN07ZJSAvqDgDm4zurkxeqvF34rmYsaxYJqrDF0yAMeta || {},
    component: () => import("/tmp/build_36c146c3/app/pages/index.vue")
  },
  {
    name: "shift",
    path: "/shift",
    meta: shiftR76TDNKvp_45c_nVwT60I3zNYfiTy2pdgUtc6qToJhBu8Meta || {},
    component: () => import("/tmp/build_36c146c3/app/pages/shift.vue")
  },
  {
    name: "role",
    path: "/:role()",
    meta: _91role_934Lp_bw1budwmPB6fR_FYX2UmJuAmcmrzvMs8ssU80wgMeta || {},
    redirect: "/:role()/home",
    component: () => import("/tmp/build_36c146c3/app/pages/[role].vue"),
    children: [
  {
    name: "role-home",
    path: "home",
    meta: homegE0DlfOnX5h7HYhfnfeLjqd2wfMsNGRV_45seBZwWra08Meta || {},
    alias: ["home"],
    component: () => import("/tmp/build_36c146c3/app/pages/[role]/home.vue")
  },
  {
    name: "role-chats",
    path: "chats",
    meta: chatstM87T0hudOl5kThZg5hakd9nupZokT48rWCnIPcmgkEMeta || {},
    alias: ["chats"],
    component: () => import("/tmp/build_36c146c3/app/pages/[role]/chats.vue")
  },
  {
    name: "role-users",
    path: "users",
    meta: usersm21EOSGOHx0M7bztH_45U_ZKaUjj3_PaT5scqOk4XWp_45gMeta || {},
    alias: ["users"],
    component: () => import("/tmp/build_36c146c3/app/pages/[role]/users.vue")
  },
  {
    name: "role-calendar",
    path: "calendar",
    meta: calendarvG9Q3A_45c93qYpC3Q41D4hXL51hyWQ_45HABw6mbrPaNJUMeta || {},
    alias: ["calendar"],
    component: () => import("/tmp/build_36c146c3/app/pages/[role]/calendar.vue")
  },
  {
    name: "role-patients",
    path: "patients",
    meta: patientsF96Pck_ub9FfnO8yYChaRnnVoBlUpHWADjDVUY1Q_45_oMeta || {},
    alias: ["patients"],
    component: () => import("/tmp/build_36c146c3/app/pages/[role]/patients.vue")
  },
  {
    name: "role-settings",
    path: "settings",
    meta: settingsoYrV_45Ktih_qpE3iTWqmyscSJxw_45slIx2XukazPTc5U8Meta || {},
    alias: ["settings"],
    component: () => import("/tmp/build_36c146c3/app/pages/[role]/settings.vue")
  },
  {
    name: "role-email-validation-token",
    path: "email/validation/:token()",
    meta: _91token_93ZI_45MtmAW0ddbUp7lI3YbyGb0EWF6qkWEP13TU00JjJAMeta || {},
    component: () => import("/tmp/build_36c146c3/app/pages/[role]/email/validation/[token].vue")
  }
]
  },
  {
    name: "sign-in",
    path: "/sign/in",
    meta: inlAPgujcrDHR5G1K30Z_KWJ1rEV1iuJ03lCh_45nXaZ_45A8Meta || {},
    component: () => import("/tmp/build_36c146c3/app/pages/sign/in.vue")
  },
  {
    name: "sign-up",
    path: "/sign/up",
    meta: upYzzY8_FRpO4hSiaJdGYEPdZp0uA_45VMUIqT32yFfbhZAMeta || {},
    component: () => import("/tmp/build_36c146c3/app/pages/sign/up.vue")
  },
  {
    name: "sign",
    path: "/sign",
    meta: indexYuLA1OAjN7j355H8ZmGLP4E8NDPpqUY5wKjTf07_45cdQMeta || {},
    redirect: "/sign/in",
    component: () => import("/tmp/build_36c146c3/app/pages/sign/index.vue")
  },
  {
    name: "print-recipe",
    path: "/print/recipe",
    meta: recipeEduNwR_45omrgNeFyotoimQlYDB7k03alqK88_QlstLLkMeta || {},
    component: () => import("/tmp/build_36c146c3/app/pages/print/recipe.vue")
  },
  {
    name: "sign-tfa",
    path: "/sign/tfa",
    meta: indexxvvsaohWRO4vgOO1SX2dFuKxZGhU2G3et7wotG_v0eUMeta || {},
    component: () => import("/tmp/build_36c146c3/app/pages/sign/tfa/index.vue")
  },
  {
    name: "sign-reset-token",
    path: "/sign/reset/:token()",
    meta: _91token_93mrYJYGhqyKnUjr1ZjgLeqLfwwc1A7G113tupXh8520IMeta || {},
    component: () => import("/tmp/build_36c146c3/app/pages/sign/reset/[token].vue")
  },
  {
    name: "sign-validation-token",
    path: "/sign/validation/:token()",
    meta: _91token_930avVOG40o96BdMbd9ODIz9neyGVqOKhmx6IuiERXi7AMeta || {},
    component: () => import("/tmp/build_36c146c3/app/pages/sign/validation/[token].vue")
  }
]